import { useState, useEffect } from 'react';
import { AddRounded, SellRounded, CloseRounded } from '@mui/icons-material';
import Input from '@components/Input';
import Text from '@components/Text';
import './styles.scss';

import api from '@services/api';
import payload from '@app/payload';
import H from '@utils/helpers';
import { CircularProgress } from '@mui/material';
import { t } from '@i18n';

export default function Coupon({
    valuesRef,
    onCouponApplied
}) {
    const [coupon, setCoupon] = useState(valuesRef.current.coupon || H.getUrlParam('coupon'));
    const [open, setOpen] = useState(false);

    const [couponData, setCouponData] = useState(null);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(null)

    // Inicializar busca de cupom quando a página carregar
    useEffect(() => {
        const urlCoupon = H.getUrlParam('coupon');
        if (urlCoupon) {
            setCoupon(urlCoupon);
            setTimeout(() => loadCoupon(urlCoupon), 0);
        }
    }, []);

    async function loadCoupon(couponCode = coupon) {
        if (!couponCode) return;
        setLoading(true);
        setCouponData(null);
        setError(null);
        try {
            const { data } = await api.get(`/community/${payload.id}/coupon?code=${couponCode}`);
            if (data.id) {
                setCouponData({ ...data });
                onCouponApplied(data)
                valuesRef.current.coupon = { ...data };
            } else {
                setError(t('coupon.notFound'))
            }
        } catch (e) {
            setError(t('coupon.notFound'))
        }
        setLoading(false);
    }

    function handleRemoveCoupon() {
        valuesRef.current.coupon = null;
        setCouponData(null);
        setOpen(true)
        setCoupon(null)
        onCouponApplied(null)
    }


    return (<>
        <div className="coupon-box" onClick={() => setOpen(true)}>
            <SellRounded sx={{ fontSize: '18px' }} />
            <Text.span className='coupon-box-title'>{t('coupon.title')}</Text.span>

            {
                open && !couponData && (
                    <Input.Text
                        disabled={loading}
                        bypassStyles
                        placeholder={t('coupon.placeholder')}
                        value={coupon}
                        onBlur={() => {
                            if (!coupon) setOpen(false);
                            loadCoupon()
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                loadCoupon();
                            }
                        }}
                        autoFocus={open}
                        onInput={(e) => setCoupon(e)}
                        className='coupon-box-input'
                    />
                )
            }

            {
                couponData ? (
                    <div className='coupon-box-data'>
                        <Text.small className='coupon-box-data-title'>{couponData.code} • {couponData.percent_off}%</Text.small>
                        <div className='remove-coupon' onClick={handleRemoveCoupon}>
                            <CloseRounded />
                        </div>
                    </div>
                ) : <div className='coupon-box-add' onClick={() => {
                    if (!coupon) return;
                    loadCoupon()
                }}>
                    {
                        loading
                            ? <CircularProgress size={20} color="inherit" />
                            : <AddRounded onClick={loadCoupon} />
                    }
                </div>
            }


        </div>
        {
            error && <div className='error-message'>
                <Text.span>{error}</Text.span>
            </div>
        }
    </>
    )
}
